"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssertionException = void 0;
const exception_1 = require("./exception");
/**
 * Indicates that some expression of soundness was determined to be false or incorrect.
 */
class AssertionException extends exception_1.Exception {
    constructor(message) {
        super(message);
        this[Symbol.toStringTag] = 'AssertionException';
        this.name = 'AssertionException';
    }
}
exports.AssertionException = AssertionException;
//# sourceMappingURL=assertion-exception.js.map